export const FILTER_OPTIONS = {
  filterKeys: [
    'bidding_types', // 比选类型
    'bidding_methods', // 比选方式
  ],
};

